<form-control-container #container [control]="controlInstance" [class.readonly]="isReadonlyValue">

  <div label-extension>
    <ng-content select="[label-extension]"></ng-content>
  </div>
  <ng-container *ngIf="!isReadonlyValue">

    <div class='input-group' *ngIf="!multiline">
      <ng-content select="[before]"></ng-content>

      <input [(ngModel)]="value" type="text" class="form-control" [ngClass]="{invalid: invalid}" [id]="controlId"
        [attr.name]="inputName" [disabled]="disabled" (focusout)="touch()"
        [autocomplete]="autocomplete ? 'on' : 'turn-off'" [attr.maxlength]="maxLength" [attr.placeholder]="placeholder"
        [attr.tabindex]="tabindex" />

      <ng-content select="[after]"></ng-content>
    </div>

    <textarea *ngIf="multiline" [(ngModel)]="value" [rows]="minRows" class="form-control" [ngClass]="{invalid: invalid}"
      [id]="controlId" [attr.name]="inputName" (focusout)="touch();" [disabled]="disabled" [attr.maxlength]="maxLength"
      [attr.placeholder]="placeholder" [attr.tabindex]="tabindex">
      </textarea>
  </ng-container>
  <ng-container *ngIf="isReadonlyValue">
    <span class="readonly-value">{{value}}</span>
  </ng-container>

</form-control-container>
